import { frontendURL } from '../../../../helper/URLHelper';
import SettingsWrapper from '../SettingsWrapper.vue';
import TeletelTeamPresenceIndex from './Index.vue';

// «حضور الفريق» (owner order 2026-09-26): administrators or roles carrying
// team_presence_view.
export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/team-presence'),
      component: SettingsWrapper,
      children: [
        {
          path: '',
          name: 'teletel_team_presence',
          meta: {
            permissions: ['administrator', 'team_presence_view'],
          },
          component: TeletelTeamPresenceIndex,
        },
      ],
    },
  ],
};
